export const exerciseStatusText = status => {
  switch (status) {
    case "passed":
      return "Completed";
    case "in_progress":
      return "Resume";
    case "not_started":
      return "Start";
    case "failed":
      return "Retry";
    default:
      return "Unknown Status";
  }
};

export const calculateTournamentStatus = (startDate, endDate, isEnrolled) => {
  const now = new Date();
  const returnVal = {
    status: "in_progress",
    statusText: "Tournament in Progress",
    buttonText: isEnrolled ? "Unenroll from Tournament" : "Enroll in Tournament",
  };

  // Determine status
  if (startDate > now) {
    returnVal.status = "not_started";
    returnVal.statusText = "Upcoming Tournament";
  }
  if (endDate < now) {
    returnVal.status = "completed";
    returnVal.statusText = "Tournament Completed";
  }

  return returnVal;
};
